import styled, { keyframes } from 'styled-components/macro';
import spinner from '~/assets/images/spinnerBeat.png';

const spinnerAnimation = keyframes`
   0% {
    background-position: 0px 0px;
  }
  100% {
    background-position: 0px -27644px;
  }
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
`;

export const OpacityLayer = styled.div`
  position: 'absolute';
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: -1;
  left: 0px;
  top: 0px;
  z-index: 10;
`;

export const Spinner = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.3);
  width: 919px;
  height: 165px;
  background: url(${spinner});
  z-index: 9999;
  animation: 5.45s steps(129) 0s infinite ${spinnerAnimation};
`;
